// extracted by mini-css-extract-plugin
export default {"item":"average-item_item__XiU9I","label":"average-item_label__nGQ4f","value":"average-item_value__cogl3"};